import _slicedToArray from "/home/runner/work/stackrox_community/stackrox_community/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/runner/work/stackrox_community/stackrox_community/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["pressed", "defaultPressed", "onPressedChange"];
import $5AXX7$babelruntimehelpersesmextends from "@babel/runtime/helpers/esm/extends";
import { forwardRef as $5AXX7$forwardRef, createElement as $5AXX7$createElement } from "react";
import { composeEventHandlers as $5AXX7$composeEventHandlers } from "@radix-ui/primitive";
import { useControllableState as $5AXX7$useControllableState } from "@radix-ui/react-use-controllable-state";
import { Primitive as $5AXX7$Primitive } from "@radix-ui/react-primitive";

/* -------------------------------------------------------------------------------------------------
 * Toggle
 * -----------------------------------------------------------------------------------------------*/
var $b3bbe2732c13b576$var$NAME = 'Toggle';
var $b3bbe2732c13b576$export$bea8ebba691c5813 = /*#__PURE__*/$5AXX7$forwardRef(function (props, forwardedRef) {
  var pressedProp = props.pressed,
    _props$defaultPressed = props.defaultPressed,
    defaultPressed = _props$defaultPressed === void 0 ? false : _props$defaultPressed,
    onPressedChange = props.onPressedChange,
    buttonProps = _objectWithoutProperties(props, _excluded);
  var _$5AXX7$useControllab = $5AXX7$useControllableState({
      prop: pressedProp,
      onChange: onPressedChange,
      defaultProp: defaultPressed
    }),
    _$5AXX7$useControllab2 = _slicedToArray(_$5AXX7$useControllab, 2),
    _$5AXX7$useControllab3 = _$5AXX7$useControllab2[0],
    pressed = _$5AXX7$useControllab3 === void 0 ? false : _$5AXX7$useControllab3,
    setPressed = _$5AXX7$useControllab2[1];
  return /*#__PURE__*/$5AXX7$createElement($5AXX7$Primitive.button, $5AXX7$babelruntimehelpersesmextends({
    type: "button",
    "aria-pressed": pressed,
    "data-state": pressed ? 'on' : 'off',
    "data-disabled": props.disabled ? '' : undefined
  }, buttonProps, {
    ref: forwardedRef,
    onClick: $5AXX7$composeEventHandlers(props.onClick, function () {
      if (!props.disabled) setPressed(!pressed);
    })
  }));
});
/*#__PURE__*/
Object.assign($b3bbe2732c13b576$export$bea8ebba691c5813, {
  displayName: $b3bbe2732c13b576$var$NAME
});
/* ---------------------------------------------------------------------------------------------- */
var $b3bbe2732c13b576$export$be92b6f5f03c0fe9 = $b3bbe2732c13b576$export$bea8ebba691c5813;
export { $b3bbe2732c13b576$export$bea8ebba691c5813 as Toggle, $b3bbe2732c13b576$export$be92b6f5f03c0fe9 as Root };